//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import tableGrid from '../tableGrid'
import cellGrid from '../cellGrid'

import BScroll from 'better-scroll'
    export default {
        name:'serveContentToast',
        data(){
            return {
              showFlag:false,
              title:'',
              cell:[],
              tabledata:{},
              titlePage:'',
              planBScroll:null,
              illnessList:[]
            }
        },
        props: {
            secondaryInfo: { // 主标题
                type: Object,
                default() { return {}}
            },
            serverTips:{
              serverTips: { // 0 保障详情  1 重疾绿通  2 100种重大疾病（ 一级页面为100种重大疾病 时 隐藏返回按钮）
                type: [Number,String],
              }
            }
        },
        components: {
          tableGrid,
          cellGrid,
        },
        created(){
           console.log('q111',this.secondaryInfo)
           this.illnessList = this.secondaryInfo.illnessList
           this.titlePage = this.secondaryInfo.title
           this.tabledata = this.secondaryInfo.tabledata
           this.$nextTick(() => {
                if (!this.planBScroll) {
                    this.planBScroll = new BScroll(this.$refs.planBox, {
                        click: true,
                        scrollY: true,
                    });
                } else {
                    this.planBScroll.refresh()
                }
            })
        },
        mounted(){
           
        },
        methods:{
          goBack(){
              this.$parent.secondaryClose();
          },
          showToast(){
            this.showFlag = true;
            this.$nextTick(() => {
                if (!this.planBScroll) {
                    this.planBScroll = new BScroll(this.$refs.planBox, {
                        click: true,
                        scrollY: true,
                    });
                } else {
                    this.planBScroll.refresh()
                }
            })
          },
          close(){
            // this.$refs.layerRef.removeTouch()
            // this.showFlag = false;
            // this.planBScroll = null;
            this.$parent.close();
          }
        }
    }
